/**
 * Per-operation context for Apollo → Hasura `x-hasura-shop-id`.
 * @see docs/HASURA_MULTI_SHOP.md
 */
export const HASURA_SHOP_CONTEXT_KEY = 'hasuraShopId' as const;
export const OMIT_HASURA_SHOP_SCOPE_KEY = 'omitHasuraShopScope' as const;

export type HasuraApolloContext = {
  [HASURA_SHOP_CONTEXT_KEY]?: string;
  [OMIT_HASURA_SHOP_SCOPE_KEY]?: boolean;
  /** Redundant path: merged into link `prevContext.headers` so `x-hasura-shop-id` survives if custom keys are missing from context. */
  headers?: Record<string, string>;
};

/** Align session header with the shop whose rows you are reading/writing. */
export function apolloContextForShop(shopId: string): HasuraApolloContext {
  return {
    [HASURA_SHOP_CONTEXT_KEY]: shopId,
    headers: { 'x-hasura-shop-id': shopId },
  };
}

/**
 * List endpoints that must see **all** tenant rows (e.g. `mst_shop` for merged catalog).
 * Use only when your Hasura role allows it without `X-Hasura-Shop-Id`.
 */
export function apolloContextUnscopedShopList(): HasuraApolloContext {
  return { [OMIT_HASURA_SHOP_SCOPE_KEY]: true };
}
